import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Carousel, CarouselItem } from '@americanexpress/dls-react';
import Slide from './Slide';
import CARD_OFFER_SHAPE from '../../constants/cardOfferShapeConstants';

const ImageSlider = ({
  offers,
  isAutoplay,
}) => {
  const { formatMessage } = useIntl();

  const offersToDisplay = offers
    .filter((item) => item.enabled)
    .map((offer, index) => {
      const adjustedIndex = index + 1;
      return (
        <CarouselItem
          id={`carouselItemID${adjustedIndex}`}
          key={`carouselItem${adjustedIndex}`}
        >
          <Slide
            index={adjustedIndex}
            offer={offer}
          />
        </CarouselItem>
      );
    });

  if (offersToDisplay.length === 0) return null;

  return (
    <Carousel
      className="radius-container no-scroll"
      shouldAutoPlay={isAutoplay}
      interval="7000"
      isSlideFullWidth={true}
      isInfinite={true}
      isNavigationOnSlides={true}
      labelOverrides={{
        'aria-label': formatMessage({ id: 'benefits.carousel.heading' }),
        nextButtonScreenReaderLabel: formatMessage({
          id: 'carousel.nextButtonLabel',
        }),
        previousButtonScreenReaderLabel: formatMessage({
          id: 'carousel.previousButtonLabel',
        }),
        playButtonScreenReaderLabel: formatMessage({
          id: 'carousel.playLabel',
        }),
        pauseButtonScreenReaderLabel: formatMessage({
          id: 'carousel.pauseLabel',
        }),
      }}
    >
      {offersToDisplay.map((offer) => offer)}
    </Carousel>
  );
};

ImageSlider.propTypes = {
  offers: PropTypes.arrayOf(PropTypes.shape(CARD_OFFER_SHAPE)),
  isAutoplay: PropTypes.bool,
};

ImageSlider.defaultProps = {
  offers: {},
  isAutoplay: true,
};

export default ImageSlider;
